/** @format */

const phrases = {
  accepted: ':attribute باید پذیرفته شده باشد.',
  active_url: 'آدرس :attribute معتبر نیست.',
  after: ':attribute باید تاریخی بعد از :date باشد.',
  after_or_equal: ':attribute باید تاریخی بعد از :date، یا مطابق با آن باشد.',
  isAlpha: ':attribute باید فقط حروف الفبا باشد.',
  isAlphaFa: ':attribute باید فقط حروف الفبا باشد.',
  isAlphaEn: ':attribute باید فقط حروف الفبا باشد.',
  alpha_dash: ':attribute باید فقط حروف الفبا، اعداد، خط تیره و زیرخط باشد.',
  alpha_num: ':attribute باید فقط حروف الفبا و اعداد باشد.',
  array: ':attribute باید آرایه باشد.',
  before: ':attribute باید تاریخی قبل از :date باشد.',
  before_or_equal: ':attribute باید تاریخی قبل از :date، یا مطابق با آن باشد.',
  between: {
    numeric: ':attribute باید بین :min و :max باشد.',
    file: ':attribute باید بین :min و :max کیلوبایت باشد.',
    string: ':attribute باید بین :min و :max کاراکتر باشد.',
    array: ':attribute باید بین :min و :max آیتم باشد.',
  },
  boolean: 'فیلد :attribute فقط می‌تواند true و یا false باشد.',
  confirmed: ':attribute با فیلد تکرار مطابقت ندارد.',
  date: ':attribute یک تاریخ معتبر نیست.',
  date_equals: ':attribute باید یک تاریخ برابر با تاریخ :date باشد.',
  date_format: ':attribute با الگوی :format مطابقت ندارد.',
  different: ':attribute و :other باید از یکدیگر متفاوت باشند.',
  digits: ':attribute باید :digits رقم باشد.',
  digits_between: ':attribute باید بین :min و :max رقم باشد.',
  dimensions: 'ابعاد تصویر :attribute قابل قبول نیست.',
  distinct: 'فیلد :attribute مقدار تکراری دارد.',
  isEmail: ':attribute باید یک ایمیل معتبر باشد.',
  isAppHash: ':attribute باید یک رشته ۱۱ حرفی و معتبر باشد.',
  isNationalCode: ':attribute معتبر نیست.',
  isMobile: ':attribute باید یک شماره معتبر باشد.',
  isPostalCode: ':attribute باید معتبر باشد.',
  isShebaAccount: ':attribute باید معتبر باشد.',
  isShebaWithPrefix: ':attribute باید معتبر باشد.',
  isCardNumber: ':attribute باید معتبر باشد.',
  isUsername: ':attribute وارد شده یک نام کاربری معتبر نیست',
  isEconomicCode: ':attribute باید معتبر باشد.',
  ends_with: 'فیلد :attribute باید با یکی از مقادیر زیر خاتمه یابد: :values',
  exists: ':attribute انتخاب شده، معتبر نیست.',
  file: ':attribute باید یک فایل معتبر باشد.',
  filled: 'فیلد :attribute باید مقدار داشته باشد.',
  isLength: 'فیلد :attribute باید :param کاراکتر داشته باشد.',
  gt: {
    numeric: ':attribute باید بزرگتر از :value باشد.',
    file: ':attribute باید بزرگتر از :value کیلوبایت باشد.',
    string: ':attribute باید بیشتر از :value کاراکتر داشته باشد.',
    array: ':attribute باید بیشتر از :value آیتم داشته باشد.',
  },
  gte: {
    numeric: ':attribute باید بزرگتر یا مساوی :value باشد.',
    file: ':attribute باید بزرگتر یا مساوی :value کیلوبایت باشد.',
    string: ':attribute باید بیشتر یا مساوی :value کاراکتر داشته باشد.',
    array: ':attribute باید بیشتر یا مساوی :value آیتم داشته باشد.',
  },
  image: ':attribute باید یک تصویر معتبر باشد.',
  in: ':attribute انتخاب شده، معتبر نیست.',
  in_array: 'فیلد :attribute در لیست :other وجود ندارد.',
  integer: ':attribute باید عدد صحیح باشد.',
  ip: ':attribute باید آدرس IP معتبر باشد.',
  ipv4: ':attribute باید یک آدرس معتبر از نوع IPv4 باشد.',
  ipv6: ':attribute باید یک آدرس معتبر از نوع IPv6 باشد.',
  json: 'فیلد :attribute باید یک رشته از نوع JSON باشد.',
  lt: {
    numeric: ':attribute باید کوچکتر از :value باشد.',
    file: ':attribute باید کوچکتر از :value کیلوبایت باشد.',
    string: ':attribute باید کمتر از :value کاراکتر داشته باشد.',
    array: ':attribute باید کمتر از :value آیتم داشته باشد.',
  },
  lte: {
    numeric: ':attribute باید کوچکتر یا مساوی :value باشد.',
    file: ':attribute باید کوچکتر یا مساوی :value کیلوبایت باشد.',
    string: ':attribute باید کمتر یا مساوی :value کاراکتر داشته باشد.',
    array: ':attribute باید کمتر یا مساوی :value آیتم داشته باشد.',
  },
  max: {
    numeric: ':attribute نباید بزرگتر از :max باشد.',
    file: ':attribute نباید بزرگتر از :max کیلوبایت باشد.',
    string: ':attribute نباید بیشتر از :max کاراکتر داشته باشد.',
    array: ':attribute نباید بیشتر از :max آیتم داشته باشد.',
  },
  mimes: 'فرمت‌های معتبر فایل عبارتند از: :values.',
  mimetypes: 'فرمت‌های معتبر فایل عبارتند از: :values.',
  min: {
    numeric: ':attribute نباید کوچکتر از :min باشد.',
    file: ':attribute نباید کوچکتر از :min کیلوبایت باشد.',
    string: ':attribute نباید کمتر از :min کاراکتر داشته باشد.',
    array: ':attribute نباید کمتر از :min آیتم داشته باشد.',
  },
  not_in: ':attribute انتخاب شده، معتبر نیست.',
  not_regex: 'فرمت :attribute معتبر نیست.',
  numeric: ':attribute باید عدد یا رشته‌ای از اعداد باشد.',
  isNumeric: ':attribute باید عدد یا رشته‌ای از اعداد باشد.',
  isNotHtmlTags: ':attribute نمیتواند تگ html باشد ',
  isMax: ':attribute نباید بزرگتر از :param باشد.', //
  isMin: ':attribute نباید کوچک‌تر از :param باشد.',
  isGt: ':attribute باید بیشتر از  :param  کاراکتر داشته باشد.',
  isLt: ':attribute باید حداکثر :param کاراکتر داشته باشد.',
  present: 'فیلد :attribute باید در پارامترهای ارسالی وجود داشته باشد.',
  regex: 'فرمت :attribute معتبر نیست.',
  required: 'فیلد :attribute الزامی است.',
  isNotContainTag: ':attribute وارد شده معتبر نیست.',
  isValidLength: ':attribute باید بین 5 تا 30 کاراکتر باشد.',
  isCorrectPostalCode: ':attribute وارد شده معتبر نیست.',
  isEmpty: 'فیلد :attribute الزامی است.',
  required_if: 'هنگامی که :other برابر با :value است، فیلد :attribute الزامی است.',
  required_unless: 'فیلد :attribute الزامی است، مگر آنکه :other در :values موجود باشد.',
  required_with: 'در صورت وجود فیلد :values، فیلد :attribute نیز الزامی است.',
  required_with_all: 'در صورت وجود فیلدهای :values، فیلد :attribute نیز الزامی است.',
  required_without: 'در صورت عدم وجود فیلد :values، فیلد :attribute الزامی است.',
  required_without_all: 'در صورت عدم وجود هر یک از فیلدهای :values، فیلد :attribute الزامی است.',
  same: ':attribute و :other باید همانند هم باشند.',
  size: {
    numeric: ':attribute باید برابر با :size باشد.',
    file: ':attribute باید برابر با :size کیلوبایت باشد.',
    string: ':attribute باید برابر با :size کاراکتر باشد.',
    array: ':attribute باید شامل :size آیتم باشد.',
  },
  starts_with: ':attribute باید با یکی از این ها شروع شود: :values',
  string: 'فیلد :attribute باید رشته باشد.',
  timezone: 'فیلد :attribute باید یک منطقه زمانی معتبر باشد.',
  unique: ':attribute قبلا انتخاب شده است.',
  uploaded: 'بارگذاری فایل :attribute موفقیت آمیز نبود.',
  url: ':attribute معتبر نمی‌باشد.',
  isURL: ':attribute معتبر نمی‌باشد.',
  isURLAndNotRequierd: ':attribute معتبر نمی‌باشد.',
  isInt: ':attribute باید فقط شامل اعداد صحیح باشد.',
  // uuid: ":attribute باید یک UUID معتبر باشد.",

  attributes: {
    firstName: 'نام',
    lastName: 'نام خانوادگی',
    name: 'نام',
    username: 'نام کاربری',
    email: 'ایمیل',
    last_name: 'نام خانوادگی',
    password: 'گذرواژه',
    password_confirmation: 'تکرار گذرواژه',
    city: 'شهر',
    country: 'کشور',
    address: 'نشانی',
    phone: 'شماره ثابت',
    mobile: 'شماره همراه',
    age: 'سن',
    sex: 'جنسیت',
    gender: 'جنسیت',
    day: 'روز',
    month: 'ماه',
    year: 'سال',
    hour: 'ساعت',
    minute: 'دقیقه',
    second: 'ثانیه',
    title: 'عنوان',
    text: 'متن',
    content: 'محتوا',
    description: 'توضیحات',
    excerpt: 'گزیده مطلب',
    date: 'تاریخ',
    time: 'زمان',
    available: 'موجود',
    size: 'اندازه',
    terms: 'شرایط',
    province: 'استان',

    // webservice
    webServiceNameFa: 'نام فارسی وب سرویس',
    scFaName: 'نام فارسی وب سرویس',
    webServiceNameEn: 'نام انگلیسی وب سرویس',
    scEnName: 'نام انگلیسی وب سرویس',
    serviceProviderName: 'نام سرویس دهنده',
    scProvider: 'نام سرویس دهنده',
    webServiceAddress: 'آدرس وب سرویس',
    scUrl: 'آدرس وب سرویس',
    currentVersion: 'شماره نسخه فعلی',
    statusCode: 'کد وضعیت HTTP',
    scHttpStatusCode: 'کد وضعیت HTTP',
    responseAnswer: 'قسمتی از پاسخ موفق',
    scHttpResponse: 'قسمتی از پاسخ موفق',
    accessType: 'نوع دسترسی',
    scClientId: 'کلید اتصال',
    serviceType: 'نوع سرویس',
    scType: 'نوع سرویس',
    httpMethod: 'Http Method',
    scHttpVerb: 'Http Method',
    setOfService: 'مجموعه سرویس ها',
    incomeCategory: 'رده درآمدی',
    soapNamespace: 'Soap namespace',
    scNamespace: 'Soap namespace',
    soapMethodName: 'soap methodname',
    scMethodName: 'soap methodname',
    calculationMethod: 'روش محاسبه',
    scPriceCalculationType: 'روش محاسبه',
    priceFix: 'قیمت ثابت',
    price: 'قیمت',
    pricePerCall: 'قیمت در هر فراخوانی',
    paymentMethod: 'روش پرداخت',
    scPaymentType: 'روش پرداخت',
    serviceDescription: 'شرح وب سرویس',
    headerName: 'نام پارامتر',
    'header.name': 'نام پارامتر',
    'body.name': 'نام پارامتر',
    'body.type': 'نوع پارامتر',
    'body.status': 'وضعیت پارامتر',
    'body.defaultValue': 'مقدار پیش فرض',
    'body.desc': 'شرح پارامتر',
    headername: 'نام پارامتر',
    'scHeaderParams.scParameterName': 'نام پارامتر',
    'header.desc': 'شرح پارامتر',
    'scHeaderParams.scParameterDesc': 'شرح پارامتر',
    'scHeaderParams.scParameterDefaultValue': 'مقدار پیش فرض',
    'scInputParams.scParameterName': 'نام پارامتر',
    'scInputParams.scParameterType': 'نوع پارامتر',
    'scInputParams.scHiddenParameter': 'وضعیت پارامتر',
    'scInputParams.scParameterDefaultValue': 'مقدار پیش فرض',
    'scInputParams.scParameterLogMode': 'وضعیت لاگ',
    'scInputParams.scParameterDesc': 'شرح پارامتر',
    headerDesc: 'شرح پارامتر',
    businessName: 'نام کسب‌وکار',
    shareAmount: 'مبلغ تسهیم',
    scPriceHeader: 'نام فیلد قیمت',
    scPriceInquiryUrl: 'آدرس استعلام قیمت سرویس',
    businessAccounts: 'حساب های کسب‌وکار',
    scGuildCode: 'حساب های کسب‌وکار',
    percentageSharing: 'درصد تسهیم',
    discountPercentage: 'درصد مشارکت در تخفیف',
    'scStakeholderList.businessId': 'نام کسب‌وکار',
    'scStakeholderList.fixedShareAmount': 'مبلغ تسهیم',
    'scStakeholderList.percentage': 'درصد تسهیم',
    'scStakeholderList.discountSharePercent': 'درصد مشارکت در تخفیف',
    scAutoApprove: 'نوع دسترسی',

    // Service set
    serviceSetName: 'نام مجموعه سرویس',
    serviceSetTag: 'برچسب مجموعه سرویس',
    serviceSetSubscription: 'اشتراک وب سرویس',
    subscriptions: 'اشتراک ها',
    CreditAmount: 'مبلغ اعتبار',
    ValidityDuration: 'مدت اعتبار',
    Number: 'تعداد',

    // Add Keys
    webAppName: 'نام اپلیکیشن/وب سایت',
    keyFormat: 'نوع کلید عمومی',
  },
};
export default phrases;
